var render = function render() {
    var _setup_payAllObj;
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('div', {
        class: _vm.$style.container
    }, [
        _c('div', {
            class: _vm.$style.panel
        }, [
            _c('p', {
                class: _vm.$style.title
            }, [
                _vm._v("Reembolsable en un futuro próximo")
            ]),
            _c('p', {
                class: _vm.$style.money
            }, [
                _vm._v("$" + _vm._s(_setup.formatAmount((_setup_payAllObj = _setup.payAllObj) === null || _setup_payAllObj === void 0 ? void 0 : _setup_payAllObj.allOutstandingBalance)))
            ]),
            _c('p', {
                class: _vm.$style.grayText
            }, [
                _vm._v(" Incluida un cargo por servicio de pago: $" + _vm._s(_setup.formatAmount(_setup.payAllObj.transactionCharge)) + " ")
            ]),
            _c('div', {
                class: _vm.$style.payCodeBox
            }, [
                _c('div', {
                    class: _vm.$style.code
                }, [
                    _c('span', [
                        _vm._v("Clabe")
                    ]),
                    _c('span', [
                        _vm._v(_vm._s(_setup.payAllObj.payBack))
                    ])
                ]),
                _c('van-button', {
                    directives: [
                        {
                            name: "clipboard",
                            rawName: "v-clipboard:copy",
                            value: _setup.payAllObj.payBack,
                            expression: "payAllObj.payBack",
                            arg: "copy"
                        },
                        {
                            name: "clipboard",
                            rawName: "v-clipboard:success",
                            value: _setup.onCopy,
                            expression: "onCopy",
                            arg: "success"
                        },
                        {
                            name: "clipboard",
                            rawName: "v-clipboard:error",
                            value: _setup.onError,
                            expression: "onError",
                            arg: "error"
                        }
                    ],
                    class: _vm.$style.btn
                }, [
                    _vm._v(" Copiar ")
                ])
            ], 1),
            _c('p', {
                class: _vm.$style.grayText
            }, [
                _vm._v(" Abrir 【APP de cualquier banco】→ seleccionar 【Transferen-cia SPEI】→ ingresar "),
                _c('span', {
                    class: _vm.$style.greenText
                }, [
                    _vm._v("【Clabe】")
                ])
            ]),
            _c('p', {
                class: _vm.$style.line
            }),
            _c('p', {
                class: _vm.$style.grayText
            }, [
                _vm._v(" Fecha de caducidad: "),
                _c('span', {
                    class: _vm.$style.blackText
                }, [
                    _vm._v(_vm._s(_setup.payAllObj.planDate))
                ])
            ])
        ]),
        _c('div', {
            class: [
                _vm.$style.panel,
                _vm.$style.guideline
            ]
        }, [
            _c('h3', [
                _vm._v("Pautas de reembolso")
            ]),
            _c('h5', [
                _vm._v("Paso 1")
            ]),
            _c('p', [
                _vm._v("Crédito Pro-copiar el código de reembolso")
            ]),
            _c('img', {
                class: _vm.$style.img1,
                attrs: {
                    "src": require("@/assets/img/repay/payment-img1.png"),
                    "alt": ""
                }
            }),
            _c('h5', [
                _vm._v("Paso 2")
            ]),
            _c('p', [
                _vm._v(" Abra la APP de cualquier banco mexicano, seleccione "),
                _c('span', {
                    class: _vm.$style.greenText
                }, [
                    _vm._v("Transferen-cia SPEI o Transferir,")
                ]),
                _vm._v(" ingrese el número de cuenta "),
                _c('span', {
                    class: _vm.$style.greenText
                }, [
                    _vm._v("Clabe")
                ]),
                _vm._v(" , mientras aparecerá automáticamente el STP del banco receptor "),
                _c('span', {
                    class: _vm.$style.grayText
                }, [
                    _vm._v(" (*Algunas APP bancarias les permitirán a los usuarios ingresar el nombre del beneficiario; ingrese " + _vm._s(_setup.payAllObj.paymentWay) + " para cuentas afiliadas e ingrese el nombre de la empresa para cuentas no afiliadas). ")
                ])
            ]),
            _c('img', {
                attrs: {
                    "src": require("@/assets/img/repay/payment-img2.png"),
                    "alt": ""
                }
            })
        ])
    ]);
};
var staticRenderFns = [];
export { render, staticRenderFns };
